let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8tsF3")).then(() => parcelRequire('goDSp'));